import React from 'react';
import Box from '@mui/material/Box';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Chip from '@mui/material/Chip';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { FeedbackTypeBadge, FeedbackStatusBadge, FeedbackClassificationBadge } from './FeedbackBadges';
import { formatDate } from '../../../../utils/Utils';

/**
 * Formata uma data 'Y-m-d H:i:s' usando formatDate() do projeto.
 * @param {string|null} dateStr
 * @returns {string}
 */
function fmtDate(dateStr) {
  if (!dateStr) return '—';
  const date = new Date(dateStr.replace(' ', 'T'));
  if (Number.isNaN(date.getTime())) return '—';
  return formatDate(date);
}

/**
 * FeedbackRow - Linha da tabela de feedbacks (Admin Geral)
 * @param {Object} props
 * @param {Object} props.feedback
 * @param {Function} props.onView
 */
function FeedbackRow({ feedback, onView }) {
  const {
    id,
    type,
    title,
    description,
    classification,
    user_name,
    user_email,
    company_name,
    screen,
    status,
    files_count,
    created_at,
  } = feedback;

  const handleView = () => {
    if (onView) onView(id);
  };

  return (
    <TableRow hover sx={{ cursor: 'pointer', '&:hover': { bgcolor: 'action.hover' } }} onClick={handleView}>
      <TableCell>
        <FeedbackTypeBadge type={type} />
      </TableCell>

      <TableCell>
        <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.primary', maxWidth: 260 }} noWrap>
          {title || description}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography variant="body2" sx={{ color: 'text.primary' }}>{user_name || '—'}</Typography>
        {user_email && (
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
            {user_email}
          </Typography>
        )}
      </TableCell>

      <TableCell>
        <Typography variant="body2">{company_name || '—'}</Typography>
      </TableCell>

      <TableCell>
        <Typography variant="body2" color="text.secondary">{screen || '—'}</Typography>
      </TableCell>

      <TableCell>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
          <FeedbackStatusBadge status={status} />
          <FeedbackClassificationBadge classification={classification} />
        </Box>
      </TableCell>

      <TableCell align="center">
        {files_count > 0 ? (
          <Chip
            size="small"
            icon={<AttachFileOutlinedIcon sx={{ fontSize: '14px !important' }} />}
            label={files_count}
            sx={{ '& .MuiChip-label': { px: 1 } }}
          />
        ) : (
          <Typography variant="body2" color="text.disabled">—</Typography>
        )}
      </TableCell>

      <TableCell>
        <Typography variant="body2" sx={{ color: 'text.primary' }}>{fmtDate(created_at)}</Typography>
      </TableCell>

      <TableCell align="right" onClick={(e) => e.stopPropagation()}>
        <Tooltip title="Ver detalhes">
          <IconButton size="small" onClick={handleView} sx={{ color: 'text.secondary' }}>
            <VisibilityOutlinedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
}

export default FeedbackRow;
